import { useEffect, useState } from "react";
import styled from "styled-components";
import Text from "@gc-npm/components.text";
import Image from "@gc-npm/components.c-image";
import Price from "@gc-npm/components.price";
import Button from "@gc-npm/components.button";
import CustomLink from "@gc-npm/components.custom-link";
import Label from "@gc-npm/components.cms-block.cms-label";
import Video from "./video-component";
import getDeviceKindDependsOnViewPort from "@gc-npm/utils.common.get-device-kind-depends-on-viewport";
import AnimatedBanner from "@/bit-components/animated-banner";

const makeUpComoponentPerso = (taggingInfo) => {
  if (taggingInfo && taggingInfo.componentPerso) {
    return JSON.stringify(taggingInfo.componentPerso);
  }
  return "";
};

const SuperContainer = styled.div`
    .super {
      a:focus-visible {
        outline-offset: 0.125rem;
      }
      .nextLinkOverBox {
        z-index: 1;
      }
      .bgfull {
        position: relative;
        margin-bottom: 1rem;
        margin-top: 1rem;
        display: flex;
        justify-content: flex-end;
        .content-container {
          z-index: 0;
          width: 100%;
          top: 0;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          gap: 0.5rem;
          padding: 1rem;
          padding-top: 65%;
          text-align: center;

          .buttonx {
            width: 100%;
          }
          .superbanner-price-cont{
            display:flex;
          }
          .superbanner-price-cont:empty {          
            display: none;
          }
        }
        .image-mobile {
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top:0;
        }
        .image-tablet {
          display: none;
          position: absolute;
          width: 100%;
          height: 100%;
          top:0;
        }
        .image-desktop {
          display: none;
          position: absolute;
          width: 100%;
          height: 100%;
          top:0;
        }

        @media screen and (min-width: 768px) {
          position: relative;
          margin-bottom: 1rem;
          margin-top: 1rem;
          padding-top: 40%;
          display: flex;
          justify-content: flex-end;
          .content-container {
            padding-top: 1.5rem;
            width: 50%;
            top: 0;
            position: absolute;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: left;
            .buttonx {
              width: unset;
            }
          }
          .image-mobile {
            display: none;
          }
          .image-tablet {
            display: block;
          }
          .image-desktop {
            display: none;
          }
        }

        @media screen and (min-width: 1024px) {
          padding-top: 24.34%;
          .content-container {
            gap: 1rem;
            padding-top: 1rem;
            justify-content: center;
          }
          .image-mobile {
            display: none;
          }
          .image-tablet {
            display: none;
          }
          .image-desktop {
            display: block;
          }
        }
      }
      .minibanner {
        position: relative;
        margin-bottom: 1rem;
        margin-top: 1rem;
        padding-top: 43.88%;
        .image-mobile {
          display: block;
        }
        .image-tablet {
          display: none;
        }
        .image-desktop {
          display: none;
        }
        .superbanner-video {
          overflow: hidden;
        }
        .video-background {
          video {
            object-fit: cover;
            width: calc(100% + 4px);
            height: 100%;
            position: absolute;
            top: -2px;
            max-width: calc(100% + 4px);
            left: -2px;
          }
        }
        @media screen and (min-width: 768px) {
          padding-top: 24.54%;
          .image-mobile {
            display: none;
          }
          .image-tablet {
            display: block;
          }
          .image-desktop {
            display: none;
          }
        }

        @media screen and (min-width: 1024px) {
          padding-top: 13.75%;
          .image-mobile {
            display: none;
          }
          .image-tablet {
            display: none;
          }
          .image-desktop {
            display: block;
          }
        }

        img {
          border-radius: 16px;
        }
      }
      .superbanner {
        background-color: ${props => props.bgColor || "#f5f5f5"};
        border-radius: 16px;
        margin-top: 1rem;
        overflow: hidden;
        height: fit-content;

        .superbanner-link-cont {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .video-background {
          video {
            width: 100%;
            height: 100%;
          }
        }

        .img-cont,
        .video-cont {
          width: 100%;
          height: 100%;
          overflow: visible;
          position: relative;
          padding-top: 80%;
          pointer-events: none;

          .main-image {
            transform: scale(1.2);
            transform-origin: bottom;
            width: 80%;
            height: 100%;
          }

          .main-video {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }

          .img-background {
            border-radius: 0rem 0rem 1rem 1rem;
            overflow: hidden;

            .img-background-linear-gradient {
              position: absolute;
              width: 7rem;
              height: 100%;
              top: 0;
              right: -1px;
              display: none;

              background: linear-gradient(
                90deg,
                rgb(88, 42, 42, 0),
                ${props => props.bgColor || "rgba(245, 245, 245, 1)"},
                ${props => props.bgColor || "rgba(245, 245, 245, 1)"}
              );
            }
          }

          .img-background {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;

            img,
            video,
            > div {
              width: 100%;
              height: 100%;
            }
          }

          img {
            object-position: bottom;
            object-fit: cover;
            position: absolute;
            bottom: 0;
            left: 0;
            position: absolute;
            bottom: 0;

            width: 100%;
          }
        }

        .video-cont {
          padding-top: 60%;
          grid-row: 1;
        }

        .superbanner-separator {
          display: none;
        }

        .content-container {
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          gap: 0.5rem;
          padding: 1rem;
          order: -1;
          margin-bottom: 1rem;

          .superbanner-title {
          }

          .superbanner-price-cont {
            margin-top: 0.75rem;
            display: flex;
            gap: 1rem;
          }
        }

        .superbanner-button-cont {
          max-width: 280px;
        }

        .display {
          &--desktop {
            display: none;
          }

          &--mobile {
            display: block;
          }
        }
      }

      .superbanner-price-cont-mobile {
        display: flex;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        flex-flow: row wrap;
      }

      @media screen and (min-width: 768px) {
        .superbanner {
          margin-top: ${props => props.layoutCompact ? "2rem" : "1rem"};
          margin-bottom: ${props => props.layoutCompact ? "2rem" : "1rem"};

          .img-cont {
            aspect-ratio: unset;
            padding-top: ${props => props.layoutCompact ? 70 : 80}%;

            .img-background {
              border-radius: 1rem 0rem 0rem 1rem;
              .img-background-linear-gradient {
                display: block;
              }
            }
          }

          .content-container {
            order: 1;
            margin-bottom: 0rem;
          }

          .display {
            &--desktop {
              display: block;
            }

            &--mobile {
              display: none;
            }
          }
        }

        .superbanner-price-cont-mobile {
          display: none;
        }
      }

      @media screen and (min-width: 1024px) {
        .superbanner {
          margin-top: ${props => props.layoutCompact ? "2rem" : " 4rem"};
          margin-bottom: ${props => props.layoutCompact ? "1rem" : "2rem"};

          .img-cont {
          }

          .superbanner-separator {
            display: block;
          }

          .content-container {
            order: 1;
            margin-bottom: 0rem;

            padding-top: ${props => props.layoutCompact ? "2rem" : "3rem"};
            padding-bottom: ${props => props.layoutCompact ? "2rem" : "3rem"};
          }
        }
      }
    }
  `;

function videoSelection(props) {
  const videoMobile = props["Video-3"];
  const videoTablet = props["Video-2"];
  const videoDesktop = props["Video-1"];

  let video = null;
  const device = getDeviceKindDependsOnViewPort();
  if (device === "MOBILE") {
    video = videoMobile;
  } else if (device === "TABLET") {
    video = videoTablet;
  } else {
    video = videoDesktop;
  }
  return video;
}
function SuperBanner(props) {
  const imageMobile = props["Image-3"];
  const imageTablet = props["Image-2"];
  const imageDesktop = props["Image-1"];
  const [video, setVideo] = useState(null);
  useEffect(() => {
    const video = videoSelection(props);
    setVideo(video);
  });

  let taggingInfo;
  try {
    taggingInfo = props.taggingInfo && {
      ...props.taggingInfo,
      componentPerso: makeUpComoponentPerso(props.taggingInfo),
      eventType: "click",
      componentContent: "contratar",
    };
  } catch (err) {}

  const hasBackgroundVideo = props["Video-2"] && props["Video-2"].src;

  const layout = props?.layout;
  const layoutCompact = props?.layout === "compact";
  const hastImageMobileTwo =
    props["ImageMobile-2"] && props["ImageMobile-2"]?.src;

  const component = props["Component"];

  if (!component || component == "") {
    return null;
  }

  let Content = <></>;

  switch (layout) {
    case "mini":
      Content = (
        <div className="minibanner">
          {imageMobile && imageMobile.src && !video && (
            <div className="image-mobile">
              <Image fill priority={true} cyData="minibanner image-mobile" {...imageMobile} />
            </div>
          )}
          {imageTablet && imageTablet.src && !video && (
            <div className="image-tablet">
              <Image
                fill
                className="image-tablet"
                cyData="minibanner image-tablet"
                priority={true}
                {...imageTablet}
              />
            </div>
          )}
          {imageDesktop && imageDesktop.src && !video && (
            <div className="image-desktop">
              <Image
                fill
                className="image-desktop"
                priority={true}
                cyData="minibanner image-desktop"
                {...imageDesktop}
              />
            </div>
          )}
          {video && video?.src && (
            <div className="video-background">
              <Video {...video} expand={false} width="100%" height="100%" />
            </div>
          )}
          <div className={`${props?.skeletonClassName}`}></div>
        </div>
      );
      break;
    case "compact":
      Content = (
        <>
          <div className="superbanner row">
            <div
              className={`col-md-5 col-sm-5 col-xs-12 ${
                hasBackgroundVideo ? "video-cont" : "img-cont"
              }`}
            >
              {!hastImageMobileTwo &&
                props["Image-2"] &&
                props["Image-2"]?.src && (
                  <div className="img-background">
                    <Image {...props["Image-2"]} width={2000} height={2000} priority={true} />
                    {props["Image-2"] &&
                      props["Image-2"]?.["linear-gradient"] && (
                        <div className="img-background-linear-gradient" />
                      )}
                  </div>
                )}

              {hastImageMobileTwo && (
                <>
                  <div className="display--desktop">
                    {props["Image-2"] && props["Image-2"]?.src && (
                      <div className="img-background">
                        <Image
                          {...props["Image-2"]}
                          width={2000}
                          height={2000}
                          priority={true}
                        />
                        {props["Image-2"] &&
                          props["Image-2"]?.["linear-gradient"] && (
                            <div className="img-background-linear-gradient" />
                          )}
                      </div>
                    )}
                  </div>

                  <div className="display--mobile">
                    {props["ImageMobile-2"] && props["ImageMobile-2"]?.src && (
                      <div className="img-background">
                        <Image
                          {...props["ImageMobile-2"]}
                          width={2000}
                          priority={true}
                          height={2000}
                        />
                        {props["ImageMobile-2"] &&
                          props["ImageMobile-2"]?.["linear-gradient"] && (
                            <div className="img-background-linear-gradient" />
                          )}
                      </div>
                    )}
                  </div>
                </>
              )}

              {props["Video-2"] && props["Video-2"]?.src && (
                <div className="video-background">
                  <Video
                    {...props["Video-2"]}
                    expand={false}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                  />
                  {props["Video-2"] &&
                    props["Video-2"]?.["linear-gradient"] && (
                      <div className="img-background-linear-gradient" />
                    )}
                </div>
              )}

              {props["Image-1"] && props["Image-1"].src && (
                <div className="main-image">
                  <Image
                    {...props["Image-1"]}
                    width={1285}
                    height={1000}
                    priority={true}
                  />
                </div>
              )}
            </div>

            {layoutCompact || <div className="superbanner-separator" />}

            <div className="content-container col-md-6 col-sm-6 col-xs-12">
              {props["LabelMobile-1"] && props["LabelMobile-1"].label && (
                <div className="display--mobile">
                  <Label {...props["LabelMobile-1"]} />
                </div>
              )}

              {props["Text-1"] && props["Text-1"].text && (
                <Text {...props["Text-1"]} />
              )}

              {props["Text-2"] && props["Text-2"].text && (
                <div className="superbanner-title">
                  <Text {...props["Text-2"]} />
                </div>
              )}

              {props["Text-3"] && props["Text-3"].text && (
                <div className="display--desktop">
                  <Text {...props["Text-3"]} />
                </div>
              )}
              <div className="display--mobile">
                {props["TextMobile-3"] && props["TextMobile-3"].text && (
                  <Text {...props["TextMobile-3"]} />
                )}

                <div className="superbanner-price-cont">
                  {props["Price-1"] && props["Price-1"].price && (
                    <Price {...props["Price-1"]} />
                  )}

                  {props["Price-2"] && props["Price-2"].price && (
                    <Price {...props["Price-2"]} />
                  )}
                </div>
                {props["Text-4"] && props["Text-4"].text && (
                  <Text {...props["Text-4"]} />
                )}
              </div>

              <div className="display--desktop">
                {props["Label-1"] && props["Label-1"]?.label && (
                  <Label {...props["Label-1"]} />
                )}

                <div className="superbanner-price-cont">
                  {props["Price-1"] && props["Price-1"].price && (
                    <Price {...props["Price-1"]} />
                  )}

                  {props["Price-2"] && props["Price-2"].price && (
                    <Price {...props["Price-2"]} />
                  )}
                </div>
              </div>

              {props["Text-4"] && props["Text-4"].text && (
                <div className="display--desktop">
                  <Text {...props["Text-4"]} />
                </div>
              )}

              <div className="display--desktop">
                {props["Button-1"] && props["Button-1"].href && (
                  <div className="superbanner-button-cont">
                    <Button {...props["Button-1"]} taggingInfo={taggingInfo} />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="display--mobile">
            <div className="superbanner-price-cont-mobile">
              {props["PriceMobile-1"] && props["PriceMobile-1"]?.price && (
                <Price {...props["PriceMobile-1"]} />
              )}

              {props["PriceMobile-2"] && props["PriceMobile-2"]?.price && (
                <Price {...props["PriceMobile-2"]} />
              )}
            </div>
          </div>
          <div className={`${props?.skeletonClassName}`}>
            <div className="row skeleton-superbanner-cont">
              <div className="col-md-4 superbanner-post-card"></div>
              <div className="col-md-4 superbanner-post-card"></div>
              <div className="col-md-4 superbanner-post-card"></div>
            </div>
          </div>
        </>
      );
      break;
    case "bgfull":
      Content = (
        <div className="bgfull">
          {imageMobile && imageMobile.src && !video && (
            <div className="image-mobile">
              <Image fill cyData="minibanner image-mobile" priority={true} {...imageMobile} />
            </div>
          )}
          {imageTablet && imageTablet.src && !video && (
            <div className="image-tablet">
              <Image
                fill
                className="image-tablet"
                cyData="minibanner image-tablet"
                priority={true}
                {...imageTablet}
              />
            </div>
          )}
          {imageDesktop && imageDesktop.src && !video && (
            <div className="image-desktop">
              <Image
                fill
                className="image-desktop"
                cyData="minibanner image-desktop"
                priority={true}
                {...imageDesktop}
              />
            </div>
          )}
          {video && video?.src && (
            <div className="video-background">
              <Video {...video} expand={false} width="100%" height="100%" />
            </div>
          )}

          <div className="content-container">
            {props["LabelMobile-1"] && props["LabelMobile-1"].label && (
              <div className="display--mobile">
                <Label {...props["LabelMobile-1"]} />
              </div>
            )}

            {props["Text-1"] && props["Text-1"].text && (
              <Text {...props["Text-1"]} />
            )}

            {props["Text-2"] && props["Text-2"].text && (
              <div className="superbanner-title">
                <Text {...props["Text-2"]} />
              </div>
            )}

            {props["Text-3"] && props["Text-3"].text && (
              <div className="display--desktop">
                <Text {...props["Text-3"]} />
              </div>
            )}

            {props["TextMobile-3"] && props["TextMobile-3"].text && (
              <div className="display--mobile">
                <Text {...props["TextMobile-3"]} />
              </div>
            )}

            {props["Label-1"] && props["Label-1"]?.label && (
              <div className="display--desktop">
                <Label {...props["Label-1"]} />
              </div>
            )}

            <div className="superbanner-price-cont">
              {props["Price-1"] && props["Price-1"].price && (
                <Price {...props["Price-1"]} />
              )}

              {props["Price-2"] && props["Price-2"].price && (
                <Price {...props["Price-2"]} />
              )}
            </div>

            {props["Text-4"] && props["Text-4"].text && (
              <div className="display--desktop">
                <Text {...props["Text-4"]} />
              </div>
            )}

            <div className="display--desktop">
              {props["Button-1"] && props["Button-1"].href && (
                <div className="superbanner-button-cont">
                  <Button {...props["Button-1"]} taggingInfo={taggingInfo} />
                </div>
              )}
            </div>
          </div>

          <div className={`${props?.skeletonClassName}`}></div>
        </div>
      );
      break;
    default:
      break;
  }

  // Si tenemos link lo englobo
  if (Content && props["CustomLink-1"] && props["CustomLink-1"].href) {
    Content = (
      <>
        <CustomLink
          {...props["CustomLink-1"]}
          taggingInfo={
            layout === "compact"
              ? taggingInfo
              : props["CustomLink-1"].taggingInfo
          }
        >
          {Content}
        </CustomLink>
      </>
    );
  }

  if (layout === "animated") {
    return (
      <SuperContainer
        $bgColor={props?.["background-color"]}
        $layoutCompact={layoutCompact}
      >
        <div className="super container">
          <AnimatedBanner {...props} fitParentContainer />
        </div>
      </SuperContainer>
    );
  } else {
    return (
      <SuperContainer
        $bgColor={props?.["background-color"]}
        $layoutCompact={layoutCompact}
      >
        <div className="super container">{Content}</div>
      </SuperContainer>
    );
  }
}

export default SuperBanner;
